/* eslint-disable no-console */
const log = console.log as typeof console.log &
  Pick<typeof console, "error" | "warn" | "debug" | "info">

log.error = console.error
log.warn = console.warn
log.debug = console.debug
log.info = console.info

export { log }
